import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-user\"><path d=\"M439.296 579.072h142.549333c184.490667 0 334.08 150.058667 334.08 335.232 0 37.034667-29.952 67.029333-66.816 67.029333H172.074667a66.944 66.944 0 0 1-66.816-67.072c0-185.130667 149.546667-335.232 334.08-335.232zM510.549333 512c-130.56 0-236.373333-105.088-236.373333-234.666667S379.946667 42.666667 510.506667 42.666667c130.602667 0 236.458667 105.088 236.458666 234.666666s-105.813333 234.666667-236.416 234.666667z\" p-id=\"1926\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user.svg
// module id = VdD3
// module chunks = 27